module.exports = __webpack_public_path__ + "img/4.3d8b5814.png";